import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["icon"];
import PropTypes from 'prop-types';
import React from 'react';
import { StyledAvatarBadge } from './AvatarBadge.styles';

/**
 * See `BadgedAvatar`
 *
 * @since 7.18.0
 */
export var AvatarBadge = function AvatarBadge(_ref) {
  var icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledAvatarBadge, rest, icon);
};
AvatarBadge.displayName = 'AvatarBadge';
AvatarBadge.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The size of the badge. Note: badges should not be used at `'xs'`, `'sm'` and `'md'` sizes.
   */
  size: PropTypes.oneOf(['xxl', 'xl', 'lg']),
  /**
   * The badge icon.
   */
  icon: PropTypes.node.isRequired
} : {};
AvatarBadge.defaultProps = {
  size: 'lg'
};